import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇬🇧', countries: 'International' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱', countries: 'Nederland, België' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪', countries: 'Deutschland, Österreich' },
  { code: 'fr', name: 'Français', flag: '🇫🇷', countries: 'France, Belgique' }
];

export default function LanguageSelectionModal({ open, onClose, detectedCountry }) {
  const { i18n } = useTranslation();
  const [selectedLang, setSelectedLang] = useState(i18n.language);

  const handleLanguageSelect = (langCode) => {
    setSelectedLang(langCode);
    i18n.changeLanguage(langCode);
    localStorage.setItem('powersure-language', langCode);
    localStorage.setItem('powersure-language-selected', 'true');
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-2xl font-light" style={{ fontFamily: 'Outfit' }}>
            Choose Your Language
          </DialogTitle>
          <DialogDescription>
            {detectedCountry && (
              <span className="text-sm text-muted-foreground">
                Detected location: {detectedCountry}
              </span>
            )}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-3 mt-4">
          {LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageSelect(lang.code)}
              className={`w-full p-4 rounded-lg border-2 transition-all hover:border-primary hover:bg-primary/5 ${
                selectedLang === lang.code ? 'border-primary bg-primary/10' : 'border-border'
              }`}
              data-testid={`lang-option-${lang.code}`}
            >
              <div className="flex items-center gap-3">
                <span className="text-3xl">{lang.flag}</span>
                <div className="text-left flex-1">
                  <div className="font-semibold">{lang.name}</div>
                  <div className="text-xs text-muted-foreground">{lang.countries}</div>
                </div>
                {selectedLang === lang.code && (
                  <span className="text-primary text-xl">✓</span>
                )}
              </div>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
